import Grid from '@blocks/Grid';
import Slider from '@blocks/Slider';
import useScopedState from '@hooks/useScopedState';
import { colors } from '@styles/vars';
import React from 'react';
import styled from 'styled-components';
import PhotoActions from './components/PhotoActions';
import PhotoTitle from './components/PhotoTitle';

export default function PhotoSlider({ onChange, onDelete, ...props }: Props) {
    const [photo, setPhoto] = useScopedState(props.photo)

    const handleChange = async (photo: Interfaces.Photo) => {
        setPhoto(photo)
        onChange(photo)
    }

    return (
        <Slider src={photo.url}>
            <Content>
                <Grid gap="10px">
                    <Grid gap="5px">
                        <PhotoTitle photo={photo} onChange={handleChange} />
                        <Original>Original: <a href={photo.url} target="_blank">{photo.width}x{photo.height}</a></Original>
                    </Grid>
                    <PhotoActions photo={photo} onChange={handleChange} onDelete={onDelete} />
                </Grid>
            </Content>
        </Slider>
    )
}

// STYLES
const Original = styled.small`
    opacity: .8;
`

const Content = styled.div`
    h4, a, small, button, p {
        color: ${colors.white};
    }

    svg {
        fill: ${colors.white};
    }
`

// TYPES
interface Props {
    photo: Interfaces.Photo
    onDelete?: (photoId: number) => any
    onChange: (photo: Interfaces.Photo) => any
}
